import { ACTION_TYPES } from 'store/common/constants/actionsTypes'
import { API } from 'utils/api/api'

interface FetchStaticActionCreatorConfig {
  staticUrl: string
  staticEntityKey: string
}

interface FetchStaticAction {
  type: string
  data?: any
}

type Dispatch = (action: FetchStaticAction) => void

export const makeFetchStaticActionCreator =
  ({ staticUrl, staticEntityKey }: FetchStaticActionCreatorConfig) =>
  () =>
  (dispatch: Dispatch): Promise<any> => {
    dispatch({
      type: ACTION_TYPES.ITEM_STATIC_FETCH_START,
    })

    return API.makeRequest({ type: 'get', requestUrl: staticUrl })
      .then(({ data }: { data: any }) => {
        dispatch({
          type: ACTION_TYPES.ITEM_STATIC_FETCH_SUCCESS,
          data: {
            [staticEntityKey]: data,
          },
        })

        return data
      })
      .catch((error: any) => {
        dispatch({
          type: ACTION_TYPES.ITEM_STATIC_FETCH_FAIL,
          data: {
            error,
          },
        })

        return Promise.reject(error)
      })
  }
